/* eslint-disable import/no-duplicates */
import { fromJS } from 'immutable';
import * as actions from '../../actions/maintenance/global';
import { START, SUCCESS, ERROR } from '../../actions/maintenance/global';
import { fetchingState } from '../../constants';

const initialStats = {
  preference: {},
  appealsType: { data: [], state: null },
  appealsStatus: { data: [], state: null },
  appealsReason: { data: [], state: null },
  revisionHistory: { data: [], totalRecords: 0, state: null },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.PREFERENCE_FETCH_START:
      return state.setIn(['preference', 'state'], fetchingState.FETCHING);
    case actions.PREFERENCE_FETCH_SUCCESS:
      const newState = state.setIn(
        ['preference', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );
    case actions.PREFERENCE_FETCH_ERROR:
      return state.setIn(['preference', 'state'], fetchingState.ERROR);

    case actions.FETCH_APPEALS_TYPE[START]:
      return state.setIn(['appealsType', 'state'], fetchingState.FETCHING);
    case actions.FETCH_APPEALS_TYPE[SUCCESS]:
      return state
        .setIn(['appealsType', 'state'], fetchingState.LOADED)
        .setIn(['appealsType', 'data'], fromJS(action.data.results || []));
    case actions.FETCH_APPEALS_TYPE[ERROR]:
      return state.setIn(['appealsType', 'state'], fetchingState.ERROR);

    case actions.FETCH_APPEALS_STATUS[START]:
      return state.setIn(['appealsStatus', 'state'], fetchingState.FETCHING);
    case actions.FETCH_APPEALS_STATUS[SUCCESS]:
      return state
        .setIn(['appealsStatus', 'state'], fetchingState.LOADED)
        .setIn(['appealsStatus', 'data'], fromJS(action.data.results || []));
    case actions.FETCH_APPEALS_STATUS[ERROR]:
      return state.setIn(['appealsStatus', 'state'], fetchingState.ERROR);

    case actions.FETCH_APPEALS_REASON[START]:
      return state.setIn(['appealsReason', 'state'], fetchingState.FETCHING);
    case actions.FETCH_APPEALS_REASON[SUCCESS]:
      return state
        .setIn(['appealsReason', 'state'], fetchingState.LOADED)
        .setIn(['appealsReason', 'data'], fromJS(action.data.results || []));
    case actions.FETCH_APPEALS_REASON[ERROR]:
      return state.setIn(['appealsReason', 'state'], fetchingState.ERROR);

    case actions.SEARCH_REVISION_HISTORY_BY_USER[START]:
      return state.setIn(['revisionHistory', 'state'], fetchingState.FETCHING);
    case actions.SEARCH_REVISION_HISTORY_BY_USER[SUCCESS]:
      return state
        .setIn(['revisionHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['revisionHistory', 'totalRecords'],
          fromJS(action.data ? action.data.totalRecords : 0),
        )
        .setIn(
          ['revisionHistory', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case actions.SEARCH_REVISION_HISTORY_BY_USER[ERROR]:
      return state.setIn(['revisionHistory', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
